import CustomDownloadComponent from "../../../components/FileDownload/CustomDownloadComponent";
import UploadedDocuments from "../../../components/UploadedDocuments/Uploaded Documents";
import { UploadedDocumentData } from "../../NewFlooringApplication/UserData";




const SellerDetails = ({ ApplicationData, GetOwnerType }) => {
  const AddLabelToFile = (arr, value) => {

    return {
      label: value,
      files: arr,
    };
  };



  const SellerDetails = ApplicationData?.vehicleInfo;


  const Company_ACRA = UploadedDocumentData[0].files;

  return (
    <section>
      {/* Application Preview */}
      <div className="preview-list-block" style={{ marginTop: "20px" }}>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Seller Name:</h3>
            <p>{SellerDetails?.seller_name}</p>
          </div>
          <div className="preview-list">
            <h3>Owner ID (Last 4 Digit):</h3>
            <p>{SellerDetails?.ownerId_last4}</p>
          </div>
          <div className="preview-list">
            <h3>Owner ID Type:</h3>
            <p>{GetOwnerType("OwnerIDType", SellerDetails?.ownerId_type)}</p>

          </div>
        </div>
      </div>

      {/* Uploaded Documents */}
      <div className="preview-list-block">
        <div className="download-block">
          <h2 className="preview-subheading">Document (s) Uploaded</h2>
          <CustomDownloadComponent />
        </div>
        {ApplicationData?.additional?.length > 0 && (
          <div className="preview-list-group">
            <UploadedDocuments
              documents={AddLabelToFile(ApplicationData?.additional, "Additional Document(s)")}
            />
          </div>
        )}
      </div>
    </section>
  );
};
export default SellerDetails;
